var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ud-card",style:({ width: (750 - _vm.marginLeft - _vm.marginRight) + 'rpx', marginLeft: _vm.marginLeft + 'rpx', marginRight: _vm.marginRight + 'rpx', borderRadius: _vm.borderRadius+ 'rpx', backgroundColor: _vm.color })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }